import { Task } from 'mixs/orders/planner_base';
import moment from 'moment';
import { Global, LineCalendarCell, LineSelectedCell } from 'mixs/orders/planner/model';

class TasksSchedulesCalendar extends Task {
  public cells: any;
  public firstDate: string;
  init(){
    super.init();
    let schedule_ids = this.opts.schedules
    let firstSchedule = this.getScheduleData(this.opts.schedules[0])
    this.firstDate = firstSchedule.start_time
    let lastSchedule = this.getScheduleData(schedule_ids[schedule_ids.length - 1])
    let startMoment   = moment(firstSchedule.start_time);
    let lastMoment    = moment(lastSchedule.end_time).add(1, 'day');
    let lastStr       = lastMoment.format('YYYY-MM-DD');
    let currentMoment = moment(firstSchedule.start_time);
    this.cells = [];
    let index = 0;
    while(currentMoment.format('YYYY-MM-DD') != lastStr){
      this.cells.push(new LineCalendarCell(currentMoment, index));
      currentMoment.add(1, 'days');
      index ++;
    }
  }
}

riot.mixin('tasks.schedules-calendar', TasksSchedulesCalendar as riot.TagMixin)
